import { useEffect, useState, JSX } from "react";
import { useKonami } from "@/context/KonamiContext";
import { announceToScreenReader } from "@/lib/accessibility";

export const KonamiEffect = (): JSX.Element | null => {
  const { konamiToggleCount, konamiEffectTrigger } = useKonami();
  const [visible, setVisible] = useState(false);

  const overLimit = konamiToggleCount > 2;

  useEffect(() => {
    if (konamiEffectTrigger > 0) {
      setVisible(true);

      // Announce to screen readers
      const message = overLimit
        ? "Konami Code limit reached. Access denied."
        : "Konami Code accepted. TRON visual mode activated.";

      announceToScreenReader(message, "assertive");

      const timer = setTimeout(() => {
        setVisible(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [konamiEffectTrigger, overLimit]);

  return visible ? (
    <div
      className="pointer-events-none fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-2xl sm:p-8"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div
        className={`w-full max-w-xs rounded-xl px-4 py-3 text-center font-extrabold drop-shadow-lg sm:max-w-sm sm:px-6 sm:py-4 md:max-w-md ${
          overLimit
            ? "animate-shake border-2 border-red-600 bg-red-100/10 text-red-500"
            : "animate-glow text-white"
        } text-2xl sm:text-3xl md:text-4xl`}
      >
        {overLimit ? "Konami Code Limit Reached — Access Denied" : "Konami Code Accepted"}
      </div>
    </div>
  ) : null;
};
